import { RadioBoxProps, RadioBox as VdsRadioBox } from "@vds/radio-boxes";

const RadioBox = ({ ...rest }: RadioBoxProps) => {
  return <VdsRadioBox {...rest} width="fit-content" />;
};

export default RadioBox;
